import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';
import * as actions from '../../store/actions';

angular.module('webTools').controller('SavedSearchCtrl', ['$scope', '$rootScope', '$routeParams', '$location', '$timeout', 'Columns', 'GridTools', 'MenuBuilder', 'Auth', 'ModalWindow', 'File', 'Utility', '$ngRedux',
    function ($scope, $rootScope, $routeParams, $location, $timeout, Columns, GridTools, MenuBuilder, Auth, ModalWindow, File, Utility, $ngRedux) {

        $scope.gridName = 'searchGrid';
      $scope.fileMenuOptions = [];
      $scope.versionedSearch = false;

        $scope.detailsMargin = '-350px';

        $scope.forms = {};
        $scope.kendo = $scope.kendo || {}; 
        $scope.breadcrumb = [{ path: 'Searches', breadcrumbName: 'Searches' }];

        $rootScope.view = 'Searches';
        $scope.breadcrumbEnabled = true;

      if (!$routeParams.page) {
        $location.search('page', 1);
        window.history.replaceState({}, '', $location.url());
      }

        /* eslint-disable  no-useless-escape */
        $scope.currentLocation = $location.url().replace(/page\=\d+/g, '');
        /* eslint-enable  no-useless-escape */

        $scope.setWorkingFolder = function() {
            $rootScope.workingFolder = $routeParams.folder || 'Searches';
            if ($routeParams.search) { $rootScope.workingFolder = $routeParams.search; }
        }

      $scope.searchGridOptions = {
            mainGrid: true,
            allowRowSelect: true,
            allowMultiselect: true,
            allowColumnState: true,
            allowSelectFolders: false,
            enableContextMenu: true,
            columnMenu: true,
            sortable: true,
            resizable: true,
            reorderable: true,
            responsive: true,
            scrollable: true,
            pageable: {
                info: true,
                refresh: false
            }
        };

        $scope.setGridOptions = function() {
            if ($routeParams.search) {
                $scope.searchGridOptions.loadOnInit = true;
                $scope.searchGridOptions.allowRowSelect = true;
                $scope.searchGridOptions.allowMultiselect = true;
                $scope.searchGridOptions.enableContextMenu = true;
                return 'api/search/GetSavedSearch?nocache=' + new Date().getTime();
            } else {
                $scope.searchGridOptions.loadOnInit = true;
                $scope.searchGridOptions.allowRowSelect = false;
                $scope.searchGridOptions.allowMultiselect = false;
                $scope.searchGridOptions.enableContextMenu = false;
                return 'api/search/GetSavedSearchList?nocache=' + new Date().getTime();
            }
        }

        $scope.getColumns = function() {
            if ($routeParams.search) {
                if ($scope.viewOnly === 'true') {
                    return Columns.getDocumentColums($rootScope.workingFolder, 'Search Documents', true);
                } else {
                    return Columns.getDocumentColums($rootScope.workingFolder, 'Search Documents');
                }
            } else {
                return Columns.getSearchColumns($rootScope.workingFolder);
            }
        };

      $scope.resetColumns = function () {
        $scope.$broadcast('hideGrid');
        Columns.resetColumns($rootScope.workingFolder, function () { $scope.selectedObject = {}; $scope.$broadcast('reloadGrid'); });
      };

        $scope.setGridOptions();
      $scope.setWorkingFolder();

      if ($routeParams.search) {
        $scope.currentSavedSearch = $routeParams.search;
      }

        $scope.searchData = {
            transport: {
                read: {
                    url: $scope.setGridOptions(),
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST'
            },
                parameterMap: function(data, operation) {

                  if ($routeParams.search) {
                    if (operation === 'read') { data = $.extend({ sort: [] }, data); }
                  } else {
                    if (data.sort && data.sort.length > 0) {
                      const sort = { sortField: data.sort[0].field, sortDirection: data.sort[0].dir };

                      if (operation === 'read') { delete data.sort; data = $.extend(sort, data); }
                    }
                  }

                    if ($routeParams.search) {
                        data = $.extend(
                            {
                                query: $routeParams.search,
                                searchOptions: {}
                            }, data);
                    } else if ($routeParams.folder) {

                        data = $.extend(
                            {
                                folderId: $routeParams.folder
                            }, data);
                    }

                  return angular.toJson(data);
                }
          },
          schema: {
              data: function (response) {
                var path = response.Path;
                $scope.$apply(() => {

                  if (response.Versioned) {
                    $scope.versionedSearch = true;
                    $scope.searchGridOptions.allowMultiselect = false;
                    $scope.searchGridOptions.enableContextMenu = true;
                  } else {
                    $scope.versionedSearch = false;
                  }

                        switch ($rootScope.workingFolder.toLowerCase()) {
                            default:
                                let pathCopy = _.cloneDeep(path);

                                pathCopy.forEach(p => p.path = `/saved-search?folder=${p.path}`)
                                $scope.breadcrumb = pathCopy;
                                break;
                        }
                    })
                    return response.Data;
                },
                total: 'TotalRows'
            },
            serverPaging: true,
            serverSorting: true,
            pageSize: 50,
            page: 1,
            sort: $scope.gridSort
      };

        $scope.currentPage = 1;

        // Use timeout so we don't refresh when adding page=1
        $timeout(() => {
            $scope.$on('$routeUpdate', function(e, data) {
                if (!$routeParams.folder) {
                    $timeout(function() { 
                        if ($scope.searchLink === true) {
                            $scope.searchLink = false;
                            $location.search({ folder: 'Searches', page: 1 });
                            return;
                        }
                    })
              }

              var currentSearch = $scope.currentSavedSearch;
              const currentFolder = $rootScope.workingFolder;

                /* eslint-disable  no-useless-escape */
                if ($routeParams.folder) { 
                  $rootScope.workingFolder = $routeParams.folder;
                }
                else if ($routeParams.search) {
                    $scope.currentSavedSearch = $routeParams.search;
                    $rootScope.workingFolder = $routeParams.search;
                }
                else {
                    $rootScope.workingFolder = 'Searches';
                }

                $scope.closeDetailsPane();
                //$scope.setNavigation();

                $scope.searchData.transport.read.url = $scope.setGridOptions();

                $scope.curentPage = data.params.page;
                $scope.currentLocation = $location.url().replace(/page\=\d+/g, '');

              $scope.selectedId = '';

              if ($routeParams.search && (currentSearch != $routeParams.search)) {
                $scope.$broadcast('reloadGrid');
              }

              if ($routeParams.folder && (currentFolder!= $routeParams.folder)) {
                $scope.$broadcast('reloadGrid');
              }
                /* eslint-enable  no-useless-escape */
            });
        })
        
        $scope.$on('gridFolderLinkClicked', function(e, data) {
            var id = GridTools.getObjectFromGrid(data, $scope.kendo[$scope.gridName]._data).ID;

            if ($routeParams.search) {
                if (_.includes(Auth.getAllowedNodes(), 'documents')) {
                    $scope.$apply(function() { $location.url('/documents').search({ folder: id, page: 1 }); });
                }
            } else {
                $scope.$apply(function() { $location.search({ folder: id, page: 1 }); });
            }
        })

        $scope.$on('gridSearchLinkClicked', function(e, data) {
            $scope.$apply(function() { $location.search({ search: GridTools.getObjectFromGrid(data, $scope.kendo[$scope.gridName]._data).ID, page: 1 }); });
        })

        $scope.selectedId = '';

		$scope.detailsPaneIsOpen = false;
		$scope.selectedObject = {};
		
		$scope.$on('gridItemSelected', function (e, data) {

			var wtObject = GridTools.getObjectFromGrid(data.id, $scope.kendo[$scope.gridName]._data);

			if(data.openDetails) {
				if (!$scope.detailsPaneIsOpen) {
					angular.element('#details-pane').css({ 'display': 'block' })
					$timeout(() => angular.element('#details-pane').css({ 'margin-right': 0 }), 100)
					$scope.detailsPaneIsOpen = true;
					$scope.selectedObject = wtObject;
				} else {
					if (data.id !== wtObject.ID && $scope.detailsPaneIsOpen) {
						$scope.selectedObject = wtObject;
					}
				}
			} else {
				if (data.id !== wtObject.ID && $scope.detailsPaneIsOpen) {
					$scope.selectedObject = wtObject;
				}
			}
			$scope.$apply();
		});

        $scope.closeDetailsPane = function() {
		    if ($scope.detailsPaneIsOpen) { angular.element('#details-pane').css({'margin-right': '-350px'}) }
		    $scope.detailsPaneIsOpen = false;
		    $scope.$broadcast('detailsPaneClosed');
        };

        $scope.selectedItems = [];

        $scope.$on('selectedItemsUpdated', function(e, selectedItems) {
            $scope.selectedItems = selectedItems;
            
            if (selectedItems.length === 0) { $scope.closeDetailsPane(); }

            if ($scope.selectedId !== '' && $scope.detailsPaneIsOpen) {
                if (!_.includes(_.map(selectedItems, 'ID'), GridTools.getObjectFromGrid($scope.selectedId, $scope.kendo[$scope.gridName]._data).ID)) {
                    if ($scope.detailsPaneIsOpen) {
                        var last = _.last(selectedItems).ID;
                        var o = _.find($scope.kendo[$scope.gridName]._data, function(ds) { return ds.ID === last; });
                        $scope.selectedId = o.uid;
                        $scope.$broadcast('populateDetails', o.uid);
                    }
                }
            }
            
            if (selectedItems.length === 0) {
              $scope.fileMenuOptions = [];
              $timeout(() => $scope.$apply())
              return;
            }

            if ($scope.versionedSearch) {
              $scope.fileMenuOptions = MenuBuilder.getVersionedSearchMenu(selectedItems, $scope.kendo[$scope.gridName]._data);
            }
            else if ($routeParams.search) {
              $scope.fileMenuOptions = MenuBuilder.getFileContextMenu(selectedItems, $scope.kendo[$scope.gridName]._data, 'documents');
            }
        });

        $scope.$on('launchLegacyDialog', function (e, data) {

          var fileIds = [];

          if ($scope.versionedSearch) {
            fileIds = _.map($scope.selectedItems, _.partialRight(_.pick, ['ID', 'Version', 'Minor', 'Name', 'Type']));
          }
          else {
            fileIds = _.map($scope.selectedItems, _.partialRight(_.pick, ['ID', 'Name', 'Type']));
          }

            var launch = function (legacyDialog) {
              window.launchLegacyDialog(legacyDialog, $scope.selectedItems, $rootScope.workingFolder, '', $scope.kendo[$scope.gridName]._data, Auth.getUsername());
            }

              // Check to see if file is member of a project on delete
              if (data === 'delete') {
                File.isInProject(_.map($scope.selectedItems, function (item) { return "'" + item.ID + "'" }).toString()).then(function (returnData) {
                  if (returnData === 'true') {
                    var m = "";
                    if ($scope.selectedItems.length === 1) {
                      m = "The selected file is in a project.<br/>Are you sure you want to delete?";
                    } else {
                      m = "One or more of the selected files are in a project.<br/>Are you sure you want to delete?";
                    }
                    ModalWindow.openConfirmation(m, function (data) { launch(data); });
                  } else {
                    launch(data);
                  }
                })
              } else { // Call React dialogs

              const packageCallback = () => { $scope.$broadcast('reloadGrid'); }

				      switch (data) {
                case 'download':
                  File.download(fileIds, 'download')
                  break;
                case 'checkout':
                  File.download(fileIds, 'checkout', packageCallback)
                  break;
                case 'undocheckout':
                  File.undoCheckout(fileIds, false, packageCallback);
                  break;
					      case 'quickapprovalworkflow':
						      const modalOptions = {
							      title: 'Quick Approval Workflow',
							      maskClosable: false,
							      footer: null
						      }
						      $ngRedux.dispatch(actions.showModal('QUICK_APPROVAL_WORKFLOW', modalOptions, { selectedItems: $scope.selectedItems }));
						      break;
					      case 'preview':

						      let previewObject = {
                    id: fileIds[0].ID,
                    version: fileIds[0].Version,
                    minor: fileIds[0].Minor
						      }

						      $scope.$emit('loadObjectPreview', previewObject);
                  break;
                case 'bravahtml':
                case 'updateprofile':
                  window.launchLegacyDialog(data, fileIds);
                  break;
					      default:
						      launch(data);
						      break;
				      }
		      }
        });
        
        $scope.$on('breadcrumbClicked', function(e, data) {
            $location.search({ folder: data.id, page: 1 });
        });
        
        $scope.closeDialog = function() {
            $scope.selectedId = '';
            $scope.$broadcast('reloadGrid');
        };

		$scope.$on('openLinkDialog', function (e, data) {
			const directLink = Utility.getLinkURL($scope.selectedItems[0].ID);
            $ngRedux.dispatch(actions.showModal('DIRECT_LINK', {title: 'Link', footer: null, width: 400}, { directLink }));
		});

        $scope.$on('openRenameDialog', function (e, data) {
            ModalWindow.openRename($scope.selectedItems[0], false, function (newName) {
                $scope.$broadcast('reloadGrid');
            });
        });

        // $scope.$on('$viewContentLoaded', function() {
        //     $scope.setNavigation();
        // });

        // $scope.setNavigation = function() {
        //     if ($routeParams.folder || $routeParams.search) {
        //         $scope.breadcrumbEnabled = true;
        //         //$scope.$apply(function() {
        //             $scope.breadcrumb = $scope.kendo.createBreadcrumb($rootScope.workingFolder);
        //         //})
        //     }
        // }

        $scope.$on('$destroy', function() {
            window.onbeforeunload = undefined;
        });
    }
])